import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  inviterLink: {
    color: theme.colorPalette.orange_50
  }
});

export default makeStyles(styles);
